var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMobileWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 28,
    viewBox: "0 0 42 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2037 6.99634H5.44783C5.10558 6.99634 4.82812 7.27379 4.82812 7.61605V12.3738C4.82812 12.7161 5.10558 12.9935 5.44783 12.9935H14.2037C14.546 12.9935 14.8234 12.7161 14.8234 12.3738V7.61605C14.8234 7.27379 14.546 6.99634 14.2037 6.99634Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1602 6.99634H35.758V12.9935H31.1602C30.9802 12.9935 30.8203 12.8336 30.8203 12.6537V7.33618C30.8203 7.15626 30.9802 6.99634 31.1602 6.99634Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4025 7H26.58C26.8075 7 27 7.22 27 7.48V21H20V7.48C20 7.22 20.1925 7 20.42 7H20.4025Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99766 26.9953C12.7578 26.9953 14.9953 24.7578 14.9953 21.9977C14.9953 19.2375 12.7578 17 9.99766 17C7.23753 17 5 19.2375 5 21.9977C5 24.7578 7.23753 26.9953 9.99766 26.9953Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23C10.5523 23 11 22.5523 11 22C11 21.4477 10.5523 21 10 21C9.44772 21 9 21.4477 9 22C9 22.5523 9.44772 23 10 23Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.998 20.9897H34.3768C35.1364 20.9897 35.7561 20.37 35.7561 19.6103V6.79634C35.7561 3.59783 33.1574 1.01904 29.9789 1.01904H2.19185C1.43221 1.01904 0.8125 1.63875 0.8125 2.3984V19.6103C0.8125 20.37 1.43221 20.9897 2.19185 20.9897H4.83062",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8127 19.0106V19.6303C40.8127 20.39 40.193 20.9897 39.4533 20.9897H33.8359",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobileWhite);
export default __webpack_public_path__ + "static/media/icon-mobile-white.45b6f9b3cc4fbd2d9ab9ecbd8983ecc0.svg";
export { ForwardRef as ReactComponent };